import { render, staticRenderFns } from "./Times.vue?vue&type=template&id=027967f3"
import script from "./Times.vue?vue&type=script&lang=ts"
export * from "./Times.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports